import { LOADING, ADD_NOTIFICATION, SHOW_LOGIN, SHOW_RESPONSIVE_MENU, MAIN_LOCK_SCROLL, WEB_STATUS, WEB_STATUS_ERR, DISPLAY_SHARE_POPUP, SET_HEADER_LOGIN, SET_MAINTENANCE, SHOW_EVENT_POPUP, SHOW_ROYAL_POPUP, SET_EID, SET_AUTH_POPUP_PANEL, AUTH_PENDING } from './type';

export function load(value) {
    return function (dispatch) {
        dispatch({
            type: LOADING,
            payload: value
        });
    }
}

/**
 * Record which auth control is currently in flight, so the auth forms can show
 * a spinner on the pressed button and disable its siblings.
 *
 * The global `<Loading />` overlay cannot do this job: it sets `zIndex: 9999`
 * inline (`components/Loading.js:8`) while the auth popup sits at
 * `z-index: 99999 !important` (`assets/beautrium-css/common.scss:642`), so it
 * paints *underneath* the popup and the user sees nothing. Raising the overlay
 * instead would veil every modal in the app on every `axios` call — see
 * `work/21h-auth-popup-loading/design.md` D1.
 *
 * Only one value is held rather than one flag per button: two concurrent
 * `signInWithPopup` calls are a real failure mode, because popup blockers
 * suppress the second window. A single value makes "one running, all others
 * disabled" the only representable state.
 *
 * @param {'facebook'|'google'|'apple'|'email'|null} provider - The control that
 *   is running, or `null` to clear once it has settled.
 * @returns {Function} redux-thunk dispatching `AUTH_PENDING`.
 */
export function setAuthPending(provider) {
    return function (dispatch) {
        dispatch({
            type: AUTH_PENDING,
            payload: provider
        });
    }
}

// export function timeout(code) {
//     if (code === "ECONNABORTED") {
//         store.dispatch(swal({
//             title: 'Internet Connection Problem',
//             text: 'Please check your internet connection and try again later.',
//             type: 'error',
//             onClose: close,
//             customClass: 'bt-dialog-box',
//         }));
//     }
// }

export function addNotification(title, message, level) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: ADD_NOTIFICATION,
            payload: null
        });
        dispatch({
            type: ADD_NOTIFICATION,
            payload: { title, message, level }
        });
    }
}

export function showAuthenticationPopup(visible = true, panel = 'login') {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SHOW_LOGIN,
            payload: { visible, panel }
        });
    }
}

export function setAuthenticationPopupShowSignupPanel(panel = 'login') {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SET_AUTH_POPUP_PANEL,
            payload: panel
        });
    }
}

export function showResponsiveMenu(visible, message = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SHOW_RESPONSIVE_MENU,
            payload: visible
        })

        if (message) {
            dispatch({
                type: SET_HEADER_LOGIN,
                payload: message
            })
        }
    }
}

export function toggleResponsiveMenu() {
    return (dispatch, getState) => {
        dispatch(showResponsiveMenu(!getState().common.show_responsive_menu))
    }
}

export function lockScroll(v) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: MAIN_LOCK_SCROLL,
            payload: v
        })
    }
}

export function queryStatus() {
    return async (dispatch, getState, { axNL }) => {
        try {
            const response = await axNL.get(`/status`);

            dispatch({
                type: WEB_STATUS,
                payload: response.data
            });
        } catch (error) {

            // Handle different error scenarios more gracefully
            if (process.env.NODE_ENV === 'development') {
                dispatch({
                    type: WEB_STATUS,
                    payload: {
                        status: 1, // STATUS.ONLINE
                        title: null,
                        type: null,
                        text: null
                    }
                });
            } else {
                // Only show maintenance in production for real server errors
                dispatch({
                    type: WEB_STATUS_ERR
                });
            }
        }
    }
}

export function displaySharePopup(visible = true) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: DISPLAY_SHARE_POPUP,
            payload: visible
        });
    }
}

export function setMaintenance(v) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SET_MAINTENANCE,
            payload: v
        })
    }
}

export function showEventPopup(v) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SHOW_EVENT_POPUP,
            payload: v
        })
    }
}

export function showRoyalPopup(v) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SHOW_ROYAL_POPUP,
            payload: v
        })
    }
}

export function setEID(v) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: SET_EID,
            payload: v
        })
    }
}